import React from 'react'
import { StyledSkeleton } from './Styled'

interface LoadingCardProps {
  height?: number | string
  width?: number | string
}

const DEFAULT_HEIGHT = 87

const LoadingCard: React.FC<LoadingCardProps> = (props: LoadingCardProps) => {
  const { height = DEFAULT_HEIGHT, width } = props

  return (
    <StyledSkeleton
      variant="rectangular"
      height={height}
      width={width}
      animation="wave"
    />
  )
}

export default LoadingCard
